import React, { useState } from "react";
import styles from "./ShareButton.module.css";
import shareIcon from "../../assets/share_red.png";
import { BASE_URL } from "../../App";

export default function ShareButton({ postId, title, firstImage }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button className={styles.shareBtn} onClick={() => setOpen(true)}>
                <img src={shareIcon} className={styles.icon} />
            </button>

            {open && (
                <SharePopup 
                    postId={postId}
                    title={title}
                    firstImage={firstImage}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
}

/* -----------------------------------------------------------
   SHARE POPUP COMPONENT
----------------------------------------------------------- */
function SharePopup({ postId, title, firstImage, onClose }) {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [selected, setSelected] = useState([]);
    const [sentMsg, setSentMsg] = useState("");
    const [sending, setSending] = useState(false);

    /* --- SEARCH USERS --- */
    const search = async (q) => {
        setQuery(q);

        if (!q.trim()) {
            setResults([]);
            return;
        }

        const res = await fetch(`${BASE_URL}/backend/search_users.php?q=@${q}`, {
            credentials: "include",
        });

        // ADDED — check unauthorized
        if (res.status === 401) {
            setSentMsg("You must be logged in to search users.");
            setTimeout(() => setSentMsg(""), 3000);
            return;
        }

        const data = await res.json();
        setResults(data || []);
    };

    /* --- ADD USER --- */
    const addUser = (u) => {
        if (!selected.find(x => x.id === u.id)) {
            setSelected([...selected, u]);
        }
    };

    /* --- REMOVE USER --- */
    const removeUser = (id) => {
        setSelected(selected.filter(x => x.id !== id));
    };

    /* --- SEND LISTING TO USERS --- */
const sendListing = async () => {
    if (!selected.length) return;

    setSending(true);

for (const receiver of selected) {

    // 1. Ensure conversation exists
    const convRes = await fetch(`${BASE_URL}/backend/messages/ensure_conversation.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ other_user_id: receiver.id })
    });

    if (convRes.status === 401) {
    setSending(false);
    setSentMsg("LOGIN_REQUIRED");

    setTimeout(() => {
        setSentMsg("");
    }, 3000);

    return;
}


    const convData = await convRes.json();
    if (!convData.conversation_id) continue;

    // 2. Build message
    const msgBody =
`Shared Listing: ${title}
https://weatherbuddy.org/HomeMate/#/houseListing/${postId}`; //update to base_url

    // 3. Send message
    const msgRes = await fetch(`${BASE_URL}/backend/messages/send_message.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            conversation_id: convData.conversation_id,
            body: msgBody
        })
    });

    if (msgRes.status === 401) {
        setSending(false);
        setSentMsg("LOGIN_REQUIRED");
        return;
    }

    // 4. Notification
    await fetch(`${BASE_URL}/backend/add_notification.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            target_user_id: receiver.id,
            message: `Someone shared a listing with you: ${title}`
        })
    });
}


    setSending(false);
    setSentMsg("Message sent");
    setTimeout(() => setSentMsg(""), 3000);
};


    /* --- RENDER POPUP --- */
    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <button className={styles.close} onClick={onClose}>×</button>

                <h2>Share Listing</h2>

                {/* Search input */}
                <input
                    className={styles.search}
                    placeholder="Search usernames…"
                    value={query}
                    onChange={(e) => search(e.target.value)}
                />

                {/* Results list */}
                <div className={styles.results}>
                    {query.trim() && results.length === 0 && (
                        <div className={styles.noResults}>No user found</div>
                    )}

                    {results.map(u => (
                        <div 
                            key={u.id} 
                            className={styles.resultItem}
                            onClick={() => addUser(u)}
                        >
                            <span>@{u.username}</span>
                        </div>
                    ))}
                </div>

                {/* Selected chips */}
                <div className={styles.selected}>
                    {selected.map(u => (
                        <div key={u.id} className={styles.chip}>
                            @{u.username}
                            <button 
                                className={styles.x} 
                                onClick={() => removeUser(u.id)}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>

                {/* SEND BUTTON */}
                <button 
                    className={styles.sendBtn}
                    disabled={sending}
                    onClick={sendListing}
                >
                    {sending ? "Sending…" : "Send"}
                </button>

                {/* SUCCESS / ERROR MESSAGE */}
{sentMsg && (
    <div
        className={
            sentMsg === "LOGIN_REQUIRED"
                ? styles.errorMsg
                : styles.sentMsg
        }
    >
        {sentMsg === "LOGIN_REQUIRED" ? (
            <>
                Please log in to share listings —{" "}
                <span
                    className={styles.loginLink}
                    onClick={() =>
                        window.location.href =
                            "https://weatherbuddy.org/HomeMate/#/login" //update to base_url
                    }
                >
                    Log in
                </span>
            </>
        ) : (
            sentMsg
        )}
    </div>
)}





            </div>
        </div>
    );
}
